"use client";

import { type FormEvent, useState } from "react";
import { useRouter } from "next/navigation";
import { cn } from "@/lib/utils";
import { SearchSubmitButton } from "./SearchSubmitButton";

interface SearchBarProps {
  initialQuery?: string;
  autoFocus?: boolean;
  className?: string;
  onSearch?: () => void;
}

/** Figma block_search: серая плашка с полем и кнопкой «искать». */
export function SearchBar({
  initialQuery = "",
  autoFocus = false,
  className,
  onSearch,
}: SearchBarProps) {
  const router = useRouter();
  const [query, setQuery] = useState(initialQuery);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (query.trim().length < 2) return;
    router.push(`/search?q=${encodeURIComponent(query.trim())}`);
    onSearch?.();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={cn("w-full border-b border-border bg-header-top-fg", className)}
    >
      <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center gap-6 px-4 py-10 md:h-20 md:flex-row md:justify-center md:gap-6 md:px-6 md:py-0 desktop:gap-10 desktop:px-20 desktop:py-10">
        <label className="flex w-full max-w-[800px] flex-col gap-2">
          <span className="sr-only">Поисковый запрос</span>
          <input
            type="search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Введите ваш запрос"
            autoFocus={autoFocus}
            className="w-full bg-transparent font-sans text-base text-tag-foreground placeholder:text-tag-foreground focus:outline-none"
          />
          <span className="block h-px w-full bg-tag-foreground" aria-hidden />
        </label>

        <SearchSubmitButton />
      </div>
    </form>
  );
}
